import React, { FC, useState } from 'react';
import {
	VictoryChart,
	VictoryArea,
	VictoryAxis,
	VictoryScatter,
	VictoryTooltip,
} from 'victory';

import { fontFamily } from '../../../../assets/themes';
import colors from '../../../../assets/colors';
import { kFormatter } from '../../../../core/helpers/numberFormatter';
import useWindowSize from '../../../../core/hooks/useWindowSize';

const maxlimit = 12;

const Chart: FC<any> = ({ data:chartData, chartWidth }) => {

const data= chartData

	if (chartData.some((elem: any )=> !!Number(elem._id) === true || !!Date.parse(elem._id)=== true)) {
	 	chartData.sort((a: any, b:any) => Number(a._id) < Number(b._id)? 1 : -1)
	 } else {
		 chartData.sort((a: any, b:any) => a._id > b._id? 1 : -1)
	 }

	const largest = [...data].sort((a: any, b: any) => b.count - a.count)[0];
    	
	const [tooltip, setTooltip] = useState(largest);
	const { width, height } = useWindowSize();
	const chartHeight = height / 2.1;

	const isMobile = width <= 768;

	if (!data.length) return null;

	return (
		<VictoryChart
			{...(width > 1024 ? { height: chartHeight } : null)}
			padding={{
				top: 20,
				bottom: 70,
				left: 70,
				right: 50,
			}}
			domainPadding={{ x: 0, y: 20 }}
			width={chartWidth}
		>
			<VictoryArea
				x="_id"
				y="count"
				name="area-1"
				data={data}
				interpolation="monotoneX"
				style={{
					data: {
						stroke: colors.darkBlue,
						strokeWidth: 5,
						strokeLinecap: 'round',
						fill: 'url(#gradient)',
					},
				}}
			/>
			<VictoryAxis
				tickFormat={t =>
					t
						.toString()
						.split(' ')
						.map((el: string) =>
							el.length > maxlimit ? el.substring(0, maxlimit - 1) + '...' : el
						)
				}
				offsetY={55}
				style={{
					axis: { stroke: 'transparent' },
					tickLabels: {
						fontFamily: fontFamily.primaryRegular,
						fontWeight: 600,
						fontSize: 14,
					},
					grid: {
						stroke: 'white',
						strokeWidth: 0,
						strokeDasharray: 0,
					},
				}}
			/>
			<VictoryAxis
				offsetX={60}
				dependentAxis
				tickFormat={t => `${kFormatter(t, true)}`}
				style={{
					axis: { stroke: 'transparent', strokeWidth: 2 },
					tickLabels: {
						fontFamily: fontFamily.primaryRegular,
						fontSize: 12,
					},
					grid: {
						stroke: colors.border,
						strokeWidth: 1,
						strokeDasharray: 6,
					},
				}}
			/>
			<VictoryScatter
				x="_id"
				y="count"
				style={{
					data: {
						stroke: colors.darkBlue,
						strokeWidth: 3,
						strokeLinecap: 'round',
						fill: colors.white,
					},
				}}
				size={({ datum, active }) =>
					datum.count === tooltip.count || active ? 6 : 6
				}
				labels={({ datum }) => datum.count}
				labelComponent={
					<VictoryTooltip
						dy={-10}
						style={{
							fontSize: 10,
							fill: '#fff',
							fontWeight: 600,
							fontFamily: fontFamily.primaryRegular,
						}}
						orientation="top"
						flyoutHeight={18.5}
						flyoutPadding={11}
						pointerLength={4}
						flyoutStyle={{ fill: colors.black }}
						renderInPortal={false}
					/>
				}
				data={data}
				events={[
					{
						target: 'data',
						eventHandlers: {
							[isMobile ? 'onTouchEnd' : 'onClick']: (evt, pressedProps) => {
								const selectedDataIndex = pressedProps.index;
								return [
									{
										eventKey: 'all',
										target: 'labels',
										mutation: props => {
											props.index === selectedDataIndex &&
												setTooltip(props.datum);

											return props.index === selectedDataIndex
												? {
													active: true,
												}
												: null;
										},
									},
									{
										eventKey: 'all',
										target: 'labels',
										mutation: props => {
											return (
												props.index === selectedDataIndex && {
													active: true,
												}
											);
										},
									},
								];
							},
						},
					},
				]}
			/>
			<linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
				<stop offset="0" stopColor="#005fc1" stopOpacity={0.4} />
				<stop offset="1" stopColor="#1263b9" stopOpacity={0} />
			</linearGradient>
		</VictoryChart>
	);
};

export default React.memo(Chart);
